import { useEffect, useState } from 'react';
import axios from 'axios';
import { PLAN_LIMITS, resolvePlanLimit } from '../../config/billingPlans';

/**
 * Loads optional auth context for /pricing: user, Stripe-related plan, and lifetime spend for plan tiers.
 */
export function usePricingPageUser() {
  const [user, setUser] = useState(null);
  const [currentPlan, setCurrentPlan] = useState({ name: 'Basic', limit: PLAN_LIMITS.Basic });
  const [totalSpent, setTotalSpent] = useState(0);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const res = await axios.get('/api/users/me');
        setUser(res.data);

        if (res.data) {
          const planRes = await axios.get('/api/billing/current-plan');
          setCurrentPlan({
            name: planRes.data.planName,
            limit: resolvePlanLimit(
              planRes.data.planName,
              planRes.data.planLimit,
            ),
          });

          const historyRes = await axios.get('/api/billing/history');
          let total = 0;
          historyRes.data.forEach((record) => {
            if (record.total) {
              const amount = parseFloat(record.total.replace(/[^0-9.-]+/g, ''));
              if (!Number.isNaN(amount)) {
                total += amount;
              }
            }
          });
          setTotalSpent(total);
        }
      } catch (error) {
        if (error.response && error.response.status !== 401) {
          console.error('Error fetching user data:', error);
        }
      }
    };

    fetchUserData();
  }, []);

  return { user, currentPlan, totalSpent };
}
